export const OV_SERVICE_NAME = 'owner_verification';

export const OV_API = {
  SALE_INFO: '/sale/get_for_sale_info/',
  CREATE_DRAFT: '/owner_verification/create_draft/',
  INITIATE: '/owner_verification/initiate/',
  UPLOAD: '/owner_verification/upload/',
  ATTACHMENTS: '/owner_verification/attachments/',
  STATUS: '/owner_verification/status/',
  RESEND: '/owner_verification/resend/',
  LINK_DATA: '/owner_verification/link_data/',
  DISPUTE: '/owner_verification/dispute/',
  CERT_META_BY_PNU: '/common/cert_meta_by_pnu/',
};

export function getCertMetaInfoUrl() {
  return 'https://calvin.disco.re/cert/cert_meta_info/';
}
